import { render, staticRenderFns } from "./app-header.vue?vue&type=template&id=57db0804&scoped=true&"
import script from "./app-header.vue?vue&type=script&lang=js&"
export * from "./app-header.vue?vue&type=script&lang=js&"
import style0 from "./app-header.vue?vue&type=style&index=0&id=57db0804&prod&lang=scss&scoped=true&"
import style1 from "./app-header.vue?vue&type=style&index=1&id=57db0804&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57db0804",
  null
  
)

export default component.exports